module.exports = __webpack_public_path__ + "img/isPro3_c4.7cef0a65.png";